import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils';

export default function MainScreen() {
  const navigate = useNavigate();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await apiFetch('/getcompany/');
        if (!cancelled) setCompany(data);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex items-center gap-3 py-12">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-slate-200 border-t-slate-900" />
        <span className="text-sm text-slate-600">Loading company data...</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold text-slate-900">FreeAgent Integration</h2>

      <div className="max-w-lg rounded-xl bg-white p-6 shadow-md">
        {company?.company ? (
          <dl className="space-y-4">
            <div className="flex gap-4">
              <dt className="w-44 shrink-0 text-sm font-semibold text-slate-600">Company Name</dt>
              <dd className="text-sm text-slate-900">{company.company.name || 'N/A'}</dd>
            </div>
            <div className="flex gap-4">
              <dt className="w-44 shrink-0 text-sm font-semibold text-slate-600">Currency</dt>
              <dd className="text-sm text-slate-900">{company.company.currency || 'N/A'}</dd>
            </div>
          </dl>
        ) : (
          <p className="text-sm text-slate-600">
            {error
              ? `Could not load company data: ${error}`
              : 'No company data available.'}
          </p>
        )}
      </div>
    </div>
  );
}
